import React from "react";
import Answer from './Answer';
import TextAnswer from './TextAnswer';
class QuizItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = { selectedAnswer: '', didSelectAnswer: false };
  }

  didSelectAnswer() {
    return this.state.selectedAnswer || this.state.didSelectAnswer;
  }

  renderAnswers() {
    if (this.props.isTextAnswer) {
      return (
        <TextAnswer isShowingAnswer={this.state.didSelectAnswer} onClick={
          () => {
            this.setState({ didSelectAnswer: !this.state.didSelectAnswer });
          }
        } />
      );
    }
    return this.props.answers.map((a) => (
      <Answer
        key={a.choice}
        choice={a.choice}
        isCorrect={a.isCorrect}
        selectedAnswer={this.state.selectedAnswer}
        questionId={`quizQuestion${this.props.number}Radios`}
        answerText={a.text}
        annotation={a.annotation}
        onClick={
          () => {
            this.setState({ selectedAnswer: a.choice });
          }
        } />
    ));
  }

  render() {
    return (
      <React.Fragment>
        <div className='circle-num'>{this.props.number}</div>
        <p className='question'>{this.props.question}</p>
        {this.renderAnswers()}
        {this.didSelectAnswer() && this.props.annotation
          ? <p className='annotation'>{this.props.annotation}</p>
          : null
        }
      </React.Fragment>
    );
  }
}
export default QuizItem;
